// Registration allowlist (Asana 1218634285737762). Shapes mirror the backend
// contract exactly; all timestamps are ISO 8601 strings.

export interface RegistrationAllowlistRow {
  id: number;
  /** Normalized by the backend (gmail dots and plus tags stripped). Display as returned. */
  email: string;
  note: string | null;
  createdAt: string;
  expiresAt: string;
  /** Set once the email has registered through the allowlist. The row stays listed until it expires. */
  usedAt: string | null;
}

/** GET /admin/registration-allowlist: every unexpired row, used ones included, newest first. */
export interface RegistrationAllowlistResponse {
  rows: RegistrationAllowlistRow[];
}

/** POST /admin/registration-allowlist. Responds 201 with the bare row. */
export interface AddRegistrationAllowlistRequest {
  email: string;
  note?: string;
}

/** 409 body code when an unexpired, unused row already exists for the normalized email. */
export const ALLOWLIST_DUPLICATE_CODE = 'ALLOWLIST_DUPLICATE';
